module.exports = __webpack_public_path__ + "static/media/reports-icon.b8e8d3a0.svg";